/**
 * Promo Category — dedicated JS for promo-driven category buttons.
 *
 * Most interaction (category switching, gallery switching, add-to-cart) is
 * handled by the existing product.js via the shared data-attribute contract.
 *
 * This file handles what product.js can't:
 *   1. Swapping the product-info content block (title, description, starter box)
 *      when the user switches between default and promo categories.
 *
 * Extend here for future promo-specific logic:
 *   - countdown timers per promo
 *   - promo-specific discount code application
 *   - analytics events
 */

document.addEventListener('DOMContentLoaded', () => {
  const categoryButtons = document.querySelector('[data-category-buttons]');
  if (!categoryButtons) return;

  const allContentBlocks = () =>
    document.querySelectorAll('[data-product-content]');

  function showProductContent(key) {
    allContentBlocks().forEach(el => {
      el.style.display = el.dataset.productContent === key ? '' : 'none';
    });
  }

  const activeBtn = categoryButtons.querySelector('[data-category].active');
  if (activeBtn) {
    const promoGallery = activeBtn.getAttribute('data-promo-gallery');
    showProductContent(promoGallery || 'default');
  }

  categoryButtons.addEventListener('click', e => {
    const btn = e.target.closest('[data-category]');
    if (!btn) return;

    const promoGallery = btn.getAttribute('data-promo-gallery');
    showProductContent(promoGallery || 'default');
  });
});
